module.exports = __webpack_public_path__ + "static/theme-editor-main-footer-1fd390a68bb958b2a3d0af113a71ddb8.png";